module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAAAAXNSR0IArs4c6QAAAWNJREFUKBVtUD1LQ0EQ3L2XoBGLFJJSQXlEEpA0gikjCpLOJo3Y2ESsAtr4C2wU0gSTX6CWgkb8QK1EREQLUUxE0MpYGGxC5L0b90IOnuJdsXezM7PLMP1zKsfPg56PhAKgQuohPz3y+pfGQaB8UEt7wAYB6SAupAtmtbyUdS8t3hFWq7WeF0JRwLwM6ZrxFTMYoHFDZvMhKg8MuYVckr+5dNboR+tzl0CT1k0pldMK747miAZHAX/b9pj4hPqis4pazZ2gSKxvlEaTfTrXwAE59CbkWysEYQqt5pYCUduCpjJIeSH6khXN1ewjLKAKcuTdVrFoZE4c921D2CmZOEohyjjkTEhQw2IyZvuy0Z5o5jtBVK4R9hr1NSEVROgYkoRxb6qElTSVmDwZUExE3NVMhuUdOKWjpxR5WJdgMyLprsdaSKeOg5XFmfidpf8SWnDzsB6TJOPm36vV40LW/bA9W38AptKOal3Uj4QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view.png
// module id = xw+N
// module chunks = 8